module.exports = __webpack_public_path__ + "img/401.floor_link.61021e09.svg";